export interface PostHogIdentity {
  userId: string;
  name?: string | null;
  email?: string | null;
  emailVerified?: boolean | null;
}

export interface PostHogIdentityUpdate {
  next: PostHogIdentity | null;
  reset: boolean;
  identify: boolean;
  registration: boolean;
}

/** These addresses belong to the repository's automation fixtures. */
export const isPostHogPlatformEmail = (email?: string | null): boolean => {
  const normalized = email?.trim().toLowerCase();
  return (
    !!normalized &&
    !['preview@imai.studio', 'e2e@imai.studio'].includes(normalized) &&
    !/^prd-rbac-[^@]+@example\.com$/.test(normalized)
  );
};

export const resolvePostHogIdentityUpdate = (args: {
  user:
    | (Omit<PostHogIdentity, 'userId'> & { userId?: string | null })
    | null
    | undefined;
  isLoading: boolean;
  isSignedOut: boolean;
  previous: PostHogIdentity | null;
  persistedUserId: unknown;
}): PostHogIdentityUpdate | null => {
  const { previous } = args;
  const user = args.isSignedOut ? null : args.user;
  // An unresolved viewer is not evidence of logout.
  if (args.isLoading || (!args.isSignedOut && !user?.userId)) return null;
  const next: PostHogIdentity | null =
    user?.userId && isPostHogPlatformEmail(user.email)
      ? {
          userId: user.userId,
          name: user.name,
          email: user.email,
          emailVerified: user.emailVerified,
        }
      : null;
  const previousId =
    previous?.userId ??
    (typeof args.persistedUserId === 'string' ? args.persistedUserId : null);
  return {
    next,
    reset: !!previousId && previousId !== next?.userId,
    identify:
      !!next &&
      (next.userId !== previous?.userId ||
        next.name !== previous.name ||
        next.email !== previous.email),
    registration:
      !!next &&
      previous?.userId === next.userId &&
      next.emailVerified === true &&
      previous.emailVerified !== true,
  };
};
